<template>
  <div class="app-monitor">
    <TopBar />
    <div class="monitor-container">
      <!-- 左侧导航栏 -->
      <div class="sidebar">
        <div class="logo">LOGO</div>
        <div class="nav-item active" @click="goToIssueList">
          <div class="nav-icon"></div>
          <span>问题与故障</span>
        </div>
        <div class="nav-item">
          <div class="nav-icon"></div>
          <span>接口监控</span>
        </div>
        <div class="nav-item">
          <div class="nav-icon"></div>
          <span>看板</span>
        </div>
      </div>
      
      <!-- 右侧内容区域 -->
      <div class="content">
        <div class="breadcrumb">
          <span>问题与故障</span>
          <span class="separator">/</span>
          <span class="current">详情</span>
        </div>
        
        <h1>问题详情</h1>
        
        <!-- 详情内容 -->
        <div class="detail-content">
          <div class="detail-section">
            <h2>基本信息</h2>
            <div class="info-grid">
              <div class="info-item">
                <label>错误类型</label>
                <span>ReferenceError</span>
              </div>
              <div class="info-item">
                <label>最近发生时间</label>
                <span>12s ago</span>
              </div>
              <div class="info-item">
                <label>发生次数</label>
                <span>4</span>
              </div>
              <div class="info-item">
                <label>APP版本</label>
                <span>V3.0.7</span>
              </div>
            </div>
          </div>
          
          <div class="detail-section">
            <h2>错误信息</h2>
            <div class="error-message">
              具体错误内容具体错误内容具体错误内容具体错误内容具体错误内容具体错误内容
            </div>
            <div class="error-file">
              <span class="file-icon"></span>
              <span>login.vue:2000行</span>
            </div>
          </div>
          
          <div class="detail-section">
            <h2>设备信息</h2>
            <div class="info-grid">
              <div class="info-item">
                <label>手机型号</label>
                <span>iPhone 13</span>
              </div>
              <div class="info-item">
                <label>操作系统</label>
                <span>iOS 15.4</span>
              </div>
              <div class="info-item">
                <label>UUID</label>
                <span>12345678-1234-1234-1234-1234567890ab</span>
              </div>
              <div class="info-item">
                <label>网络环境</label>
                <span>4G</span>
              </div>
            </div>
          </div>
          
          <div class="detail-section">
            <h2>发生历史</h2>
            <table class="history-table">
              <thead>
                <tr>
                  <th>时间</th>
                  <th>设备</th>
                  <th>版本</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>12s ago</td>
                  <td>iPhone 13</td>
                  <td>V3.0.7</td>
                </tr>
                <tr>
                  <td>2min ago</td>
                  <td>iPhone 13</td>
                  <td>V3.0.7</td>
                </tr>
                <tr>
                  <td>5min ago</td>
                  <td>iPhone 12</td>
                  <td>V3.0.6</td>
                </tr>
                <tr>
                  <td>10min ago</td>
                  <td>iPhone 13</td>
                  <td>V3.0.7</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "./Top.vue";

export default {
  name: "IssueDetail",
  components: {
    TopBar,
  },
  data() {
    return {
      // 详情数据
    };
  },
  methods: {
    goToIssueList() {
      this.$router.push("/app-monitor");
    },
  },
  mounted() {
    // 加载详情数据
  },
};
</script>

<style scoped lang="less">
.app-monitor {
  padding-top: 80px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.monitor-container {
  display: flex;
  min-height: calc(100vh - 80px);
}

/* 左侧导航栏 */
.sidebar {
  width: 200px;
  background-color: #fff;
  border-right: 1px solid #e0e0e0;
  padding: 20px 0;
  
  .logo {
    padding: 0 20px 20px;
    font-weight: bold;
    font-size: 18px;
  }
  
  .nav-item {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    cursor: pointer;
    transition: all 0.3s;
    
    &:hover {
      background-color: #f0f0f0;
    }
    
    &.active {
      background-color: #e6f7ff;
      color: #1890ff;
    }
    
    .nav-icon {
      width: 20px;
      height: 20px;
      background-color: #d9d9d9;
      margin-right: 10px;
      border-radius: 4px;
    }
    
    span {
      font-size: 14px;
    }
  }
}

/* 右侧内容区域 */
.content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  max-height: calc(100vh - 80px);
  
  .breadcrumb {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
    
    .separator {
      margin: 0 8px;
    }
    
    .current {
      color: #1890ff;
    }
  }
  
  h1 {
    color: #333;
    margin-bottom: 20px;
    font-size: 20px;
  }
  
  h2 {
    color: #555;
    margin: 0 0 15px;
    font-size: 16px;
  }
}

/* 详情内容 */
.detail-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-section {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* 信息网格 */
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  
  .info-item {
    display: flex;
    flex-direction: column;
    
    label {
      font-size: 12px;
      color: #999;
      margin-bottom: 5px;
    }
    
    span {
      font-size: 14px;
      color: #333;
    }
  }
}

/* 错误信息 */
.error-message {
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #cf1322;
  line-height: 1.5;
}

.error-file {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #1890ff;
  
  .file-icon {
    width: 14px;
    height: 14px;
    background-color: #1890ff;
    margin-right: 8px;
    border-radius: 2px;
  }
}

/* 历史表格 */
.history-table {
  width: 100%;
  border-collapse: collapse;
  
  th, td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #f0f0f0;
  }
  
  th {
    background-color: #fafafa;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
  
  td {
    font-size: 14px;
    color: #666;
  }
}
</style>